import CallHandler from "./modules/CallHandler";

document.querySelector("body").onload = () => CallHandler.handleCall();
